import { render, staticRenderFns } from "./l-block-wrap.vue?vue&type=template&id=6a0f08be&scoped=true&"
import script from "./l-block-wrap.vue?vue&type=script&lang=ts&"
export * from "./l-block-wrap.vue?vue&type=script&lang=ts&"
import style0 from "./l-block-wrap.vue?vue&type=style&index=0&id=6a0f08be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0f08be",
  null
  
)

export default component.exports